/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyReplacementDataSelectionType {
    EXISTING_COMPOSITE_DATA_CUTS = 'existingCompositeDataCuts',
    PRICING_POLICY = 'pricingPolicy',
    RESET_DATA_CUTS = 'resetDataCuts',
}
